import { configureStore } from "@reduxjs/toolkit";
import weddingReducer from "./features/weddingSlice";
import { saveWeddingState } from "./persistence";

export const store = configureStore({
  reducer: {
    wedding: weddingReducer
  }
});

if (typeof window !== "undefined") {
  store.subscribe(() => saveWeddingState(store.getState()));
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;